import { FC } from 'react'

import useParametrizationConfigTolerancia from '@hook/parametrization/use-config-tolerancia'

import PurchaseCsvExportItem, {
  PurchaseCsvColumn
} from './PurchaseCsvExportItem'

const COLUMNS: PurchaseCsvColumn[] = [
  { header: 'Empresa', field: 'empresaId' },
  { header: 'Perfil Nome', field: 'perfilNome' },
  { header: 'Tolerancia', field: 'tolerancia' }
]

const ActionExcelPurchaseToleranciaExport: FC = () => {
  const { dataTolerancias = [], companieId } =
    useParametrizationConfigTolerancia()

  const getRows = () =>
    dataTolerancias.map(tolerancia => ({
      empresaId: companieId,
      perfilNome: tolerancia['nome-usuario'],
      tolerancia: tolerancia.tolerancia
    }))

  return (
    <PurchaseCsvExportItem
      filenamePrefix="tolerancia-compra"
      columns={COLUMNS}
      getRows={getRows}
      rowCount={dataTolerancias.length}
    />
  )
}

export default ActionExcelPurchaseToleranciaExport
